<template>
  <div class="main">
    <report-top>
      <ly-search slot="search" v-model="searchItem.keyword" @search="search"></ly-search></report-top>
    <selectTool ref="selectTool">
      <template slot="btn">
        <Button @click="getSearchItem" type="error" class="chaxun">查询</Button>
          <Button type="primary" class="chaxun">新增</Button>
          </template></selectTool>

    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)">

      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openDetail(row)">查看详情</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <fujian ref="fujian"></fujian>
  </div>
</template>
<script>
import fujian from "./ascSelectFujian.vue";
var alarmTypeList=[];
export default {
  components:{fujian},
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "车牌号",
          key: "carNo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "设备号",
          key: "deviceNo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "报警名称",
          key: "alarmTypeName",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "一级报警",
          key: "firstLevel",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "二级报警",
          key: "secondLevel",
          minWidth: 100,
          maxWidth: 200,
        },

        {
          title: "三级报警",
          key: "thirdLevel",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "总次数",
          key: "total",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "单位名称",
          key: "groupName",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "事件描述",
          key: "evetDesc",
          minWidth: 200,
          maxWidth: 300,
        },
         {
          title: "开始时间",
          key: "startTime",
          minWidth: 100,
          render: (h, {row}) => {
            return h("div", this.utils.time(row.startTime, "yymmddhhmm"));
          }
        },
        {
          title: "结束时间",
          key: "endTime",
          minWidth: 100,
          render: (h, {row}) => {
            return h("div", this.utils.time(row.endTime, "yymmddhhmm"));
          }
        },
        {
          title: "操作",
          slot: "action",
          width: 90,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      searchItem: {
        endTime: 0,
        startTime: 0,
        alarmIdList: [],
        deviceIdList: [],
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "2,0",
        },{
          title: "车牌号",
          key: "deviceIdList",
          type: "selectAlotCar",

        },{
          title: "报警类型",
          key: "alarmIdList",
          type: "Select",
          multiple:true,
          selectType:'obj',
          selectItems:alarmTypeList

        },
      ],
      total: 0,
      categorys: [],

    };
  },
  methods: {
    getList() {
     console.log(this.searchItem);
     this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.alarm + "/alarmAsc/sum",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;


        this.tableData = data;
      });
    },
    openDetail(v){
      this.$refs.fujian.open(v)
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },

    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    getAlarmTypeList() {
      this.axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "alarmAscType",
        },
      }).then((res) => {
        var data = JSON.parse(res.data.data.value);
        alarmTypeList.length=0;
        for (let i = 0; i < data.length; i++) {
          var obj = {
            id: data[i].id,
            name: data[i].name,
          };
        alarmTypeList.push(obj);

          //this.alarmTypeIdList[i] = obj.alarmTypeId; //全选
          //全选
          //this.$emit("alarmData", allAlarm);
        }
      });
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols([], this.columns);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
    this.getAlarmTypeList();
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/alarm/ascSelect.vue